import { type Player, type Shirt as ShirtProps } from '@common/clients/api';
import { type MatchEvent } from '@common/types/MatchEvent';
import styles from '@web/molecules/FootballFormation/FootballFormation.module.scss';

import { PlayerElement } from '../PlayerElement';

interface Props {
    formation: string;
    players: Player[];
    events: MatchEvent[];
    isLineUpGenerator?: boolean;
    isHomeTeam?: boolean;
    shirt?: ShirtProps;
    setSelectedPlayerID?: (_: string) => void;
}

/** Minimum number of players per line to show curves */
const MINIMUM_CURVE_COUNT = 4;

export const TeamFormation = ({
    formation,
    players,
    events,
    isLineUpGenerator = false,
    isHomeTeam = false,
    shirt,
    setSelectedPlayerID,
}: Props) => {
    const formationPlayers: Player[][] = [];

    // The first line will always be the goalkeeper
    const formationLines = [1];
    formation.split('').forEach((line) => {
        formationLines.push(Number(line));
    });

    let index = 0;
    for (const lineSize of formationLines) {
        formationPlayers.push(players.slice(index, index + lineSize));
        index += lineSize;
    }

    return (
        <>
            {formationPlayers.map((line, index) => {
                const lineClasses = [styles.line];
                if (line.length >= MINIMUM_CURVE_COUNT) {
                    lineClasses.push(
                        index < formationPlayers.length - 1
                            ? styles['defending-curve']
                            : styles['attacking-curve'],
                    );
                }

                return (
                    <div key={`line-${index + 1}`} className={lineClasses.join(' ')}>
                        {line.map((player) => {
                            return (
                                <PlayerElement
                                    key={`player-${player.id}`}
                                    player={player}
                                    events={events}
                                    isLineUpGenerator={isLineUpGenerator}
                                    setSelectedPlayerID={setSelectedPlayerID}
                                    isHomeTeam={isHomeTeam}
                                    shirt={shirt}
                                />
                            );
                        })}
                    </div>
                );
            })}
        </>
    );
};
